export default __webpack_public_path__ + "static/media/tools-icon.b28de948.svg";